
import { Button } from "@/components/ui/button";
import { Pencil, Trash2, Clock } from "lucide-react";

interface ClassListItemProps {
  class_: any;
  onEdit: (class_: any) => void;
  onDelete: (id: string) => void;
  onClick: () => void;
}

export const ClassListItem = ({ class_, onEdit, onDelete, onClick }: ClassListItemProps) => {
  // Función para formatear el horario
  const formatSchedule = (schedule: string) => {
    // Si el horario ya tiene el formato correcto (XX:XX), lo devolvemos tal cual
    if (/^\d{2}:\d{2}$/.test(schedule)) {
      return schedule;
    }

    // Si es solo un número (ej: "8" o "14")
    const hour = parseInt(schedule);
    if (!isNaN(hour)) {
      // Añadimos cero a la izquierda si es necesario y agregamos ":00"
      return `${hour.toString().padStart(2, '0')}:00`;
    }

    // Si no podemos formatear, devolvemos el valor original
    return schedule;
  };

  return (
    <div
      className="flex items-start justify-between p-4 bg-background rounded-lg border cursor-pointer hover:border-primary/50 transition-colors"
      onClick={onClick}
    >
      <div className="space-y-1">
        <h3 className="font-medium text-primary">{class_.title}</h3>
        <p className="text-sm text-muted-foreground">{class_.description}</p>
        <div className="text-sm text-muted-foreground">
          <p className="text-muted-foreground">Instructor: {class_.instructor}</p>
          <p className="text-muted-foreground">Horario: {formatSchedule(class_.schedule)}</p>
          <p className="text-muted-foreground">Capacidad: {class_.capacity}</p>
          <p className="flex items-center gap-2">
            <Clock className="h-4 w-4" />
            <p>Duración: {class_.duration} minutos</p>
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onEdit(class_)}
        >
          <Pencil className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(class_.id)}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
